import { ITreeNode } from '../hierarchy-interfaces';
import { buildTree, DENDROGRAM_DOT_RADIUS } from '../domain/hierarchy-provider';

interface DendrogramProps {
    map: Map<string, ITreeNode>;
    root: string;
    letters: string[];
}

const Dendrogram = ({ map, letters }: DendrogramProps) => {

    const { nodes, width, height } = buildTree(map, letters);

    return (
        <svg
            className="border bg-slate-100"
            width={ width }
            height={ height + 50 }>

            <line x1={ 0 } y1={ height } x2={ width } y2={ height } stroke="black" />

            {
                nodes.map((node, i) => {

                    return (
                        <g key={ i }>
                            <circle
                                cx={ node.x }
                                cy={ node.y }
                                r={ DENDROGRAM_DOT_RADIUS }
                            />
                            <text
                                x={ node.x - DENDROGRAM_DOT_RADIUS }
                                y={ node.y + DENDROGRAM_DOT_RADIUS * 5 }>
                                { node.letter }
                            </text>

                            {
                                node.lines.map((line, l) => {
                                    return (
                                        <line
                                            key={ `line-${ l }` }
                                            x1={ line.x1 }
                                            y1={ line.y1 }
                                            x2={ line.x2 }
                                            y2={ line.y2 }
                                            stroke={ line.stroke || 'black' }
                                        />
                                    )
                                })
                            }
                        </g>
                    )
                })
            }

        </svg>
    )
};

export default Dendrogram;
